import * as React from "react";
import './SVGRoadMap.scss'

function SvgComponent(props) {

  const {children} = props
  
  return (
    <svg
      id="prefix__Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      x={0}
      y={0}
      viewBox="0 0 442.5 219"
      xmlSpace="preserve"
      {...props}
    >
      <defs>
        <pattern id="image" x="-64" y="-64" patternUnits="userSpaceOnUse" height="128" width="128">
            <image x="0" y="0" height="128" width="128" href="http://0.gravatar.com/avatar/902a4faaa4de6f6aebd6fd7a9fbab46a?s=64"/>
        </pattern>
    </defs>
      <g id="prefix__XMLID_25_">
        <path
          id="prefix__XMLID_20_"
          className="prefix__st0"
          d="M45.4 118.1l56.2 37.5"
        />
        <path
          id="prefix__XMLID_21_"
          className="prefix__st0"
          d="M163.1 48.4l-61.5 34"
        />
        <path
          id="prefix__XMLID_22_"
          className="prefix__st0"
          d="M225.6 83.9l-62.5 34.2"
        />
        <path
          id="prefix__XMLID_23_"
          className="prefix__st0"
          d="M219.5 148.4l61.8 37.5"
        />
        <path
          id="prefix__XMLID_26_"
          className="prefix__st0"
          d="M282.4 120.7l56 34.1"
        />
        <path
          id="prefix__XMLID_24_"
          className="prefix__st0"
          d="M339.6 83.9l56 34.2"
        />
      </g>
      <g id="prefix__XMLID_18_">
        <path
          id="prefix__XMLID_3_"
          className="prefix__st1"
          d="M45.4 116.9l56.2-34.5 124 73.2"
        />
        <path
          id="prefix__XMLID_19_"
          className="prefix__st1"
          d="M225.6 155.6l170-107.2"
        />
      </g>
      {children}
      <g id="prefix__XMLID_28_">
        <circle
          id="prefix__XMLID_7_"
          className="prefix__st3"
          cx={225.6}
          cy={83.9}
          r={20.8}
        />
        <circle
          id="prefix__XMLID_12_"
          className="prefix__st3"
          cx={161.9}
          cy={49.9}
          r={20.8}
        />
        <circle
          id="prefix__XMLID_16_"
          className="prefix__st3"
          cx={395.6}
          cy={116.9}
          r={20.8}
        />
        <circle
          id="prefix__XMLID_15_"
          className="prefix__st3"
          cx={280.9}
          cy={186.6}
          r={20.8}
        />
        <circle
          id="prefix__XMLID_10_"
          className="prefix__st3"
          cx={101.6}
          cy={155.6}
          r={20.8}
        />
        <circle
          id="prefix__XMLID_9_"
          className="prefix__st3"
          cx={343.9}
          cy={155.6}
          r={20.8}
        />
      </g>
    </svg>
  );
}

export default SvgComponent;

